import { useEffect, useState } from "react";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { useNavigate } from "react-router-dom";

// styles
import "./Project.css";
import {
  dbDataStore,
  messageAndErrorStore,
  projectStore,
  userStore,
} from "../../store/Store";

export default function ProjectComments() {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const currentProject = projectStore((data) => data.currentProject);
  const users = dbDataStore((data) => data.users);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // local
  const [projectComments, setProjectComments] = useState([]);
  const [newComment, setNewComment] = useState({
    project_id: currentProject.project.id,
    project_comments: "",
    created_by_id: currentUser.id,
  });
  const navigate = useNavigate()
  // convert seconds into a date
  const makeDate = (d) => {
    const created = new Date(d);
    return formatDistanceToNow(created.getTime(), { addSuffix: true });
  };

  const getUser = (id) => {
    const user = users.filter((u) => {
      return u.id === id;
    });
    return `${user[0].first_name} ${user[0].last_name}`;
  };

  const handleChange = (e) => {
    setNewComment({
      ...newComment,
      project_comments: e.target.value,
    });
  };

  useEffect(() => {
    if (currentProject) {
      setProjectComments(currentProject.comments);
    }
  }, [currentProject]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify(newComment),
      signal: controller.signal
    };

    fetch(`${process.env.REACT_APP_BACKEND}/pc/comment`, requestOptions)
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            setAuthStatus(false)
            navigate("/login")
            return
          } else {
            toggleNewMessage(`Something went wrong Error ${res.status}`)
            return Promise.resolve()
          }
        } else {
          return res.json()
        }
      })
      .then((data) => {
        if (!data) {
          return
        } else {
          setNewComment({
            ...newComment,
            project_comments: "",
          });
          setProjectComments(data)
        }
      })
      .catch((err) => console.log(err));
    return () => controller.abort();
  };
  
  return (
    <div className="col-3">
      {currentProject && (
        <div className="p-1 border text-center project-card project-comments">
          <h5>Comments</h5>
          <ul>
            {projectComments &&
              projectComments.map((comment) => (
                <li key={comment.id}>
                  <div className="comment-author">
                    <p>{getUser(comment.created_by_id)}</p>
                  </div>
                  <div className="comment-content">
                    <p>{comment.project_comments}</p>
                  </div>
                  <div className="comment-content">
                    <p>{makeDate(comment.created_at)}</p>
                  </div>
                </li>
              ))}
          </ul>
          {!currentProject.archived && (
            <form className="row g-3" onSubmit={handleSubmit}>
              <div className="col-md-12">
                <label>
                  <span>Add a Comment:</span>
                  <textarea
                    required
                    onChange={handleChange}
                    value={newComment.project_comments}
                  />
                </label>
              </div>
              <div className="col-12">
                <button className="btn btn-secondary">Add</button>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
}
